"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newly = void 0;
exports.newly = {
    chrome: '141',
    edge: '141',
    firefox: '147',
    safari: '26.2',
    ios: '26.2',
};
exports.default = Object.entries(exports.newly).map(([b, v]) => `${b} >= ${v}`);
//# sourceMappingURL=newly.js.map